export const Warning = ({ styles }: { styles: string }) => {
  return (
    <div className="bg-[--synapse-text] text-[--synapse-root] rounded-full text-xs font-bold w-3 h-3 p-0.5 inline-flex justify-center items-center">
      !
    </div>
  )
}
